import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  APP_INITIALIZER,
  ErrorHandler,
} from '@angular/core';
import {
  provideRouter,
  withViewTransitions,
  withComponentInputBinding,
  withPreloading,
  withInMemoryScrolling,
} from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { authInterceptor, errorInterceptor } from './core/auth/interceptors/auth.interceptor';
import { baseUrlInterceptor } from './core/http/interceptors';
import {
  cacheInterceptor,
  optimisticUpdateInterceptor,
} from './core/http/interceptors/cache.interceptor';
import { AuthService, initializeAuth } from './core/auth/services/auth.service';
import { GlobalErrorHandler } from './core/error/services/global-error-handler';
import { IdlePreloadStrategy } from './core/routing/idle-preload.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    // Register global error handler
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true,
    },
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withViewTransitions({
        onViewTransitionCreated: ({ transition }) => {
          // Handle view transition errors gracefully
          // Swallow, don't break navigation - view transitions are optional, and an
          // unhandled rejection here would surface as a console error of its own.
          transition.ready.catch(() => undefined);
        },
      }),
      withComponentInputBinding(),
      // Idle-time preloading rather than PreloadAllModules: chunks still arrive before
      // the user navigates, but no longer contend with the first page's own requests.
      withPreloading(IdlePreloadStrategy),
    ),
    provideHttpClient(
      withInterceptors([
        baseUrlInterceptor,
        authInterceptor,
        cacheInterceptor,
        optimisticUpdateInterceptor,
        errorInterceptor,
      ]),
      withFetch(),
    ),
    provideAnimations(),
  ],
};
